import { CircleArrowEdge } from "./CircleArrowEdge";

export const edges = [
  {
    id: "platform->airdrop",
    source: "platform",
    target: "airdrop",
    sourceHandle: "right",
    targetHandle: "top",
    type: "animatedCircle",
    data: {
      delay: 5000,
    },
    markerEnd: {
      type: "arrowclosed",
    },
  },
  {
    id: "airdrop->players",
    source: "airdrop",
    target: "players",
    sourceHandle: "bottom",
    targetHandle: "right",
    type: "animatedCircle",
    data: {
      delay: 7500,
    },
    markerEnd: {
      type: "arrowclosed",
    },
  },
  {
    id: "players->game",
    source: "players",
    target: "game",
    sourceHandle: "left",
    targetHandle: "bottom",
    type: "animatedCircle",
    data: {
      delay: 0,
    },
    markerEnd: {
      type: "arrowclosed",
    },
  },
  {
    id: "game->players",
    source: "game",
    target: "players",
    sourceHandle: "right",
    targetHandle: "top",
    type: "animatedCircle",
    data: {
      delay: 2500,
    },
    markerEnd: {
      type: "arrowclosed",
    },
  },
  {
    id: "game->platform",
    source: "game",
    target: "platform",
    sourceHandle: "top",
    targetHandle: "left",
    type: "animatedCircle",
    data: {
      delay: 2500,
    },
    markerEnd: {
      type: "arrowclosed",
    },
  },
  {
    id: "platform->dex",
    source: "platform",
    target: "dex",
    sourceHandle: "bottom",
    targetHandle: "top",
    type: "animatedCircle",
    data: {
      delay: 5000,
    },
    markerEnd: {
      type: "arrowclosed",
    },
  },
  {
    id: "dex->players",
    source: "dex",
    target: "players",
    sourceHandle: "bottom",
    targetHandle: "top",
    type: "animatedCircle",
    data: {
      delay: 7500,
    },
    markerEnd: {
      type: "arrowclosed",
    },
  },
];

export const edgeTypes = {
  animatedCircle: CircleArrowEdge,
}
